import {
    Box,
    Typography
} from "@mui/material";

import AuditLog from "./AuditLog";

export default function AdminAuditPage() {
    return (
        <Box>
            <Typography
                variant="h4"
                gutterBottom
            >
                Audit Log
            </Typography>

            <Typography
                color="text.secondary"
                sx={{ mb: 3 }}
            >
                Review changes made to collection
                information and other auditable activity.
            </Typography>

            <AuditLog />
        </Box>
    );
}